import { APIClient } from "../api";
import axios, { AxiosAdapter } from 'axios';
export default class BusinessAreaService extends APIClient {

    constructor(props: any) {
        super(props);
    }

    async getByUserId(userId: number) {
        const url = this.endpoint + `/BusinessArea/User/${userId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async getByUserAttendantUserId(userId: number) {
        const url = this.endpoint + `/BusinessArea/UserAttendant/${userId}`;

        if (typeof this.cancelToken != typeof undefined) {
            this.cancelToken.cancel("Operation canceled due to new request.")
        }

        //Save the cancel token for the current request
        this.cancelToken = axios.CancelToken.source();
        return this.api({
            method: 'get',
            url,
            cancelToken: this.cancelToken.token
        });
    }
}